import PropTypes from 'prop-types';

export default ({isThirdPartyReservation: PropTypes.bool,
  showModifyModal: PropTypes.func.isRequired,
  thirdPartyReservationSupportNumber: PropTypes.string,
  showCancelModal: PropTypes.func.isRequired,
  isTourReservation: PropTypes.bool,});
